import React from "react";
import  { useState, useEffect } from 'react';
import './classes/HockeyEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const HockeyEducationProgram = () => {

    // const navigate = useNavigate();
    const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);
   const [testimonialsData, setTestimonialsData] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Harry Sinden",
                image: "/basic/web/images/scout/harry_sinden_collage.jpg",
                description: "NHL Hall of Famer <strong>Harry Sinden</strong> is a living legend of the game of hockey, his name immortalized on the Stanley Cup twice, once as a coach of the 1970 Boston Bruins championship team, and again as an executive with the Bruins 2011 championship squad. Over his 50 years as a coach, GM, President and Senior Advisor to the Boston Bruins,Sindenwas instrumental in leading the team to a North American major professional record 30 consecutive playoff appearances, which included five Stanley Cup finals.Before getting into coaching, Sinden was an accomplished player, winning the silver medal as a member of the Canadian national men's hockey team in the 1960 Winter Olympics. To learn the inside game of hockey from someone as experienced as Harry Sinden is a chance unlike any other. Students speak directly each week with Harry Sinden, and after successful completion of this course you can add him as a reference to your resume.",
               
             },
             {
                name: "Mike Oke",
                image: "/basic/web/images/scout/Mike_Oke_Mug_Shot.jpg",
                description: "Since 2013, <strong>Mike Oke</strong> has been the general manager of the Peterborough Petes of the Ontario Hockey League (OHL) after joining the team three years earlier as the manager of player personnel. Prior to joining the Petes, Mike worked with the International Scouting Service (ISS) as Chief Scout where he was responsible for day-to-day operations and managing the scouting staffs responsible for developing scouting reports on players eligible for the NHL Draft, as well as the WHL, QMJHL, OHL and CHL import drafts. Mike also has a deep background in coaching having been an Assistant Coach in charge of video with Team Pacific at the 2008 World Under 17 Hockey Challenge, the Director of Player Personnel and Assistant Coach with the Oshawa Generals,an Assistant Coach at Wilfrid Laurier University of the Ontario University Athletic Association and Head Coach/Manager with the Trenton Sting of the Ontario Provincial Junior A Hockey League. Oke has assisted with over 100 SMWW graduates acquiring jobs in professional and collegiate hockey. The team of Sinden and Oke can get you where you want to go!",
               
             },
            
        ];
        setMentors(mentors);

        const courseTopics = [
            "ISS has developed its own unique method of evaluating players' strengths and weaknesses and demonstrate their knowledge of the game as well as improve their ability to evaluate players. Player evaluation reports involve some of the following:",
            "Skating Mobility - Quickness, Foot speed, Agility (Lateral), Strength & Balance",
            "Hockey Sense - Makes good play, takes good hockey decision, relaxed, good-excellent on face-off",
            "Puck Control - Receiving a Pass, Making a Pass, Stick handling, Controls the Play - Makes Def. Make1st. Move",
            "Play Away Offensively - Position, Run Interference, Spectator",
            "From Puck Defensively - Anticipation, Positional Sound, Transition Game",
            "Shooting - # of Shots (Backhand, Wrist, Slap), Eye Hand (Make Something out of Nothing), No. of Goals (Accuracy)",
            "Physical Game - Proportion (Upper & Lower Body), Stamina & Cardio (Over Game), Body Checking (Gains Puck), Quiet Checking (Knocks Player off Puck), In Corner/Front of Net (Position - Upper Body), Taking a Hit, Fighting.",
            ];
        setCourseTopics(courseTopics);

        const initialTestimonials  = [
        {
            id: 1,
            name: "Jens Casten",
            title: "JC27 International Goalie Consulting",
            image: "/basic/web/images/scout/picture-1105-1441602821.jpg",
            link: "/testimonial/jens-casten",
            body: `I was a Pro Goalie for 21 years and had to retire suddenly due to an injury, without any direction concerning my future career. 
            I was immediately impressed with the SMWW concept and felt that enrolling in their educational programs could be greatly beneficial to my professional future off the ice. 
            SMWW online education is the way of the future bringing the sports world together. 
            SMWW chats provide an excellent forum for the exchange of ideas and relating of experience, and networking with people from all over the globe. 
            I have just completed the Agent Management Course and will stay with SMWW as an Agent Advisor. 
            I have also enrolled in the Hockey General Manger Course and am looking forward to the guidance of SMWW and EJ Hradek. 
            I wish I had come across SMWW 10 years ago. Dr. Lashbrook is a great mentor with impressive knowledge and leadership.`
        }
        ];
        setTestimonialsData(initialTestimonials);

    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="hockey-education-progarm-main">
                <Helmet><title>Hockey Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="hockey-education-progarm-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW Hockey Education Program</h1>
                            <p>SMWW Hockey Scouts have been trained and mentored by some of the best in the industry. SMWW Hockey Scouts have completed a rigorous eight week training program and instructed by International Scouting Services Chief Scouts, Former Boston Bruin GM Harry Sinden. In addition they have been trained in Rinknet and Steva Digital Video Editing. SMWW Hockey Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the high school, university, major junior, or professional level.</p>
                            <h2>SMWW Hockey Scouting Mentors:</h2>
                            {mentors.map((mentor,index) => (
                                <>
                                    <p key={index}>
                                        <div className="scout-mentors" key={mentor.name} style={{ overflow: "auto" }}>
                                            <img
                                                src={mentor.image}
                                                alt={mentor.name}
                                                className="mentor-image"
                                            />
                                            <span>
                                                <span dangerouslySetInnerHTML={{ __html: mentor.description }} />
                                            </span>
                                        </div>
                                    </p>
                                    <p style={{marginTop: "0px"}}>&nbsp;</p>
                                </>
                            ))}
                            <h2>SMWW Hockey Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <p>&nbsp;</p>
                                <a className="reddbtnn" href={`https://${configData.RSMWW_DOMAIN}/application`}>
                                    Apply today for training as an SMWW Certified Hockey Scout
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                                <span><strong><a href="/scout-sports/hockey">Click here</a> to search for a SMWW Hockey Scout by Area.</strong><br/>
                                SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span>
                            </p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                            <p>&nbsp;</p>
                    </div>
                  
                    </div>
                </div>
                <div className="right hockey-education-right">
                     <div id="block-views-testimonials-block" className="block block-views">
                    <h2>Testimonials:</h2>

                  <div className="">
                        <div className="view view-testimonials">
                        <div className="">
                            <div className="testimonial-wrapper">
                            <ul>
                                {testimonialsData.map((testimonial) => (
                                <li
                                    key={testimonial.id}
                                    className="views-row"
                                >
                                    <div className="desktop_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyloaded"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            style={{ width: "100px", height: "100px" }}
                                        />
                                        </div>
                                    </div>

                                    <div className="views-field views-field-title title">
                                        <span className="field-content">
                                        <a href={testimonial.link}>{testimonial.name}</a>
                                        </span>
                                    </div>

                                    <div className="views-field views-field-field-author-title text">
                                        <div className="field-content">{testimonial.title}</div>
                                    </div>

                                    <div className="views-field views-field-body">
                                        <div className="field-content">
                                        <p>{testimonial.body}</p>
                                        </div>
                                    </div>
                                    </div>

                                   

                                    <div className="mobile_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyload testimonial_mobile_image"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                        />
                                        </div>
                                    </div>

                                    <div className="testimonial_wrapper_mobile">
                                        <div className="testimonial_left_content">
                                        <div className="testimonial_title">
                                            <a href={testimonial.link}>{testimonial.name}</a>
                                        </div>
                                        <br />
                                        <div className="testimonial_tag_line">
                                            {testimonial.title}
                                        </div>
                                        </div>
                                        <div className="testimonial_right_content">
                                        <div className="testimonial_body_content">
                                            <p>{testimonial.body}</p>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                ))}
                            </ul>
                            </div>
                        </div>
                        </div>
                    </div>
                   

                    </div>
                </div>
            </div>
        )}
        </>
    );
};
export default HockeyEducationProgram;